<template>
	<article v-bind:class="[passedCSS]" v-bind:data-id="stopdata.wpid">
		<div v-if="dataFullTF" class="stop-wrapper-full">
			<div class="moving-date-wrap" v-bind:class="'decade-' + dataFull.decade">
				<span class="moving-date tbs" v-html="dataFull.date"></span>
			</div>
			<button
				class="closeX"
				v-on:click="closeEl()"
				v-bind:data-id="dataFull.wpid"
			></button>
			<div class="text-content">
				<h2 class="cent no-hov" v-html="dataFull.title"></h2>
				<span
					v-if="stopdata.date && +stopdata.date >= 1971"
					class="blok classification cent minus"
					v-html="dataFull.classify"
				></span>
			</div>
			<Media v-bind:mediadata="dataFull.media"></Media>
		</div>
		<div v-if="!dataFullTF" class="stop-wrapper" v-bind:class="{'hasAudio' : stopdata.audio}">
			<KeyMedia v-bind:allowMediaLoad="allowMediaLoad" v-bind:mediadata="stopdata.key_media"></KeyMedia>
			<div class="text-content">
				<span
					class="blok date minus cent"
					v-html="stopdata.date"
				></span>
				<h2 class="cent balance-target no-hov">
					<a
						v-on:click.stop.prevent="fetchData()"
						:href="
							'/interactives/moma_through_time/' + stopdata.decade + '/' + stopdata.slug + '/'
						"
						class="stop-wrap"
						v-bind:class="'balance-'+_uid"
						v-html="stopdata.title"
					></a>
				</h2>
				<span
					v-if="stopdata.date && +stopdata.date >= 1971"
					class="blok classification cent minus"
					v-html="stopdata.classify"
				></span>
			</div>
		</div>
		<Audio v-bind:audiodata="stopdata.audio" v-if="stopdata.audio"></Audio>
		<div v-if="dataFullTF" class="stop-wrapper-full">
			<div class="description" v-html="dataFull.description"></div>

			<div class="more-link" v-if="dataFull.url">
				<a
					:href="dataFull.url"
					class="inh"
					v-html="moreLinkText(dataFull.a_text)"
				></a>
			</div>
			
			<div
				v-if="dataFull.see_also !== null"
				class="blok stop-seealso rest-width">
				See also: <a :href="'/interactives/moma_through_time' + dataFull.see_also.url" v-html="dataFull.see_also.title"></a>
			</div>

			<div
				v-if="dataFull.credits"
				class="blok stop-credits minus rest-width"
				v-html="dataFull.credits"
			></div>
		</div>
	</article>
</template>

<script>
import Media from "./Media.vue";
import KeyMedia from "./KeyMedia.vue";
import Audio from "./Audio.vue";
import textBalancer from 'text-balancer';
var inView = require('in-view');
inView.offset({
	top: -100,
	bottom: -300,
});
export default {
	components: {
		Media,
		KeyMedia,
		Audio
	},
	created() {
		// esline-disable-next-line
		// console.log(this.$parent.$parent.initopen);
		
		let initPath = this.$parent.$parent.wpTarget;
		if (initPath !== null && initPath === this.stopdata.slug) {
			this.fetchData();
		}
	},
	mounted() {
		let ivThis = this;
		inView('.article-'+ivThis.stopdata.wpid)
			.once('enter', function(){
				// console.log(document.querySelector('.article-'+ivThis.stopdata.wpid).classList);
				setTimeout(function(){
					if(document.querySelector('.article-'+ivThis.stopdata.wpid).classList.contains('autoload')){
						ivThis.fetchData();
					}
				},300);
				ivThis.allowMediaLoad = true;
				ivThis.$parent.needsResize = true;
				// console.log(ivThis.$refs.balance);
				setTimeout(function(){
					textBalancer.balanceText('.balance-'+ivThis._uid);
				},100);
			})
			.on('enter', el => {
				el.classList.add("iv");
			})
			.on('exit', el => {
				el.classList.remove("iv");
			});
	},
	data() {
		return {
			publicPath: process.env.BASE_URL,
			dataFullTF: false,
			dataFull: null,
			allowMediaLoad:false,
			passedCSS: [
				this.stopdata.cssclass,
				"single",
				"stop-" + this.stopdata.decade,
				"article-" + this.stopdata.wpid,
				"article-" + this.stopdata.slug,
				"loop-" + this.loopinstance
			]
		};
	},
	props: ["rootPath","apiPath","stopdata", "loopinstance","lPos","activeDecade"],
	methods: {
		fetchData() {
			// this.error = this.dataFull = null
			// eslint-disable-next-line
			// console.log(process.env);

			let localThis = this;
			// console.log(localThis.stopdata.title);
			localThis.$root.$data.pageTitle = localThis.stopdata.title;


			if (localThis.dataFull === null) {
				localThis.loading = true;
				localThis.passedCSS.push("isLoading");
				// flag fetch
				// const baseURI =
				// 	this.apiPath +
				// 	"/?get=data-write&preview=1&wpid=" +
				// 	this.stopdata.wpid;
				const baseURI = this.rootPath + 'static/uploads/data/p-'+this.stopdata.wpid+'.js?v=1.05';
				setTimeout(function(){
					localThis.$http
						.get(baseURI)
						.then(result => {
							// this.users = result.data
							localThis.dataFull = result.data[0]["articles"][0];
							localThis.dataFullTF = true;
							localThis.passedCSS.push("isOpen");
							localThis.$parent.needsResize = true;

							window.cb();

							setTimeout(function() {
								// localThis.smoothScroll(
								// 	".article-" + localThis.stopdata.wpid
								// );
								localThis.loading = false;
								if (
									localThis.passedCSS !== null &&
									typeof localThis.passedCSS !== "undefined"
								) {
									localThis.passedCSS = localThis.passedCSS.filter(
										item => item !== "isLoading"
									);
								}
								textBalancer.balanceText('.isOpen h2.cent');

							}, 50);

							setTimeout(function(){
								localThis.$parent.needsResize = true;
							},1000);
						})
						.catch(function(err) {
							localThis.error = err.toString();
							localThis.loading = false;
							this.passedCSS = this.passedCSS.filter(
								item => item !== "isLoading"
							);
						});
				}, 150);
			} else {
				localThis.dataFullTF = true;
				localThis.passedCSS.push("isOpen");
				window.cb();
			}
			// eslint-disable-next-line
			// console.log('New URL: ' + '/'+localThis.stopdata.decade+'/' + localThis.stopdata.slug + '/');
			localThis.$parent.$parent.$parent.setNewURL(
				localThis.publicPath +
					localThis.stopdata.decade +
					"/" +
					localThis.stopdata.slug +
					"/"
			);
		},
		closeEl() {
			this.dataFullTF = false;
			this.passedCSS = this.passedCSS.filter(item => item !== "isOpen");
			this.passedCSS = this.passedCSS.filter(
				item => item !== "isLoading"
			);
			window.cb();
			this.$parent.needsResize = true;
			this.$root.$data.pageTitle = '';
			// eslint-disable-next-line
			// console.log('New URL: ' + '/'+this.stopdata.decade+'/');
			this.$parent.$parent.$parent.setNewURL(this.publicPath + this.stopdata.decade + "/");
		},
		moreLinkText(existText) {
			if (existText !== "") {
				return existText;
			} else {
				return "More information on Maid";
			}
		},
		currentYPosition() {
			if (self.pageYOffset) return self.pageYOffset;
			if (document.documentElement && document.documentElement.scrollTop)
				return document.documentElement.scrollTop;
			if (document.body.scrollTop) return document.body.scrollTop;
			return 0;
		},
		elmYPosition(eID) {
			var elm = document.querySelector(eID);
			var y = elm.offsetTop - 90;
			var node = elm;
			while (node.offsetParent && node.offsetParent != document.body) {
				node = node.offsetParent;
				y += node.offsetTop;
			}
			return y;
		},
		smoothScroll(eID) {
			var startY = this.currentYPosition();
			var stopY = this.elmYPosition(eID);
			var distance = stopY > startY ? stopY - startY : startY - stopY;
			if (distance < 100) {
				scrollTo(0, stopY);
				return;
			}
			var speed = Math.round(distance / 100);
			if (speed >= 20) speed = 20;
			var step = Math.round(distance / 25);
			var leapY = stopY > startY ? startY + step : startY - step;
			var timer = 0;
			if (stopY > startY) {
				for (let i = startY; i < stopY; i += step) {
					setTimeout(
						"window.scrollTo(0, " + leapY + ")",
						timer * speed
					);
					leapY += step;
					if (leapY > stopY) leapY = stopY;
					timer++;
				}
				return;
			}
			for (let i = startY; i > stopY; i -= step) {
				setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
				leapY -= step;
				if (leapY < stopY) leapY = stopY;
				timer++;
			}
		},
		loadMedia: function() {
			// console.log("triggering inview");
			// this.allowMediaLoad = true;
		}
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
article {
	position: relative;
	.stop-wrapper {
		padding: 16px 28px 20px;
		&.hasAudio {
			padding-bottom:71px;
			& + .audio-wrap {
				margin-top:-51px;
			}
		}
	}
	.stop-wrapper-full {
		padding-left:24px;
		padding-right:24px;
	}
	section:not(.up) & {
		margin-left: auto;
		margin-right: auto;
	}
	width: 100%;
	display: flex;
	flex-direction: column;
	transition-duration: 0.15s;
	transition-property: opacity, transform;
	@include aboveTablet {
		mix-blend-mode:multiply;
	}
	&.isLoading {
		opacity: 0;
		transform:translateY(5px);
		// box-shadow:0px 0px 2px #000000;
	}
	&.isOpen {
		opacity: 0;
		transform:translateY(5px);
		background: rgba(0, 0, 0, 0.88);
		color: #fff;
		padding-top: 72px;
		padding-bottom: 90px;
		max-width: 100%;
		flex-basis: 100%;
		animation: fadedownin 0.4s 0s forwards;
		@include aboveTablet {
		}
		h2 {
			margin: 0 auto 50px;
			@media (min-width: 700px) {
				padding-left: 40px;
				padding-right: 40px;
			}
			@media (min-width: 1024px) {
				max-width: 800px;
				margin-left: auto;
				margin-right: auto;
			}
		}
		.up & {
			h2 + .classification {
				margin-top: -50px;
				padding-top: 0.75em;
				margin-bottom: 2.7em;
			}
		}
	}

	&:not(.isOpen) {
		.up-1 &.single:not(.single-el){
			flex-basis: 50%;
			flex-shrink: 0;
			margin:auto;
			> div:not(.audio-wrap) { 
				max-width: 350px;
				margin:auto;
			}
			@include tabletBelow {
				flex-basis: 50%;
			}
			@include aboveTablet {
				&.isOpen {
				}
			}
		}
		.up-2 & {
			flex-basis: 50%;
			flex-shrink: 0;
			> div:not(.audio-wrap) { 
				max-width: 350px;
				margin:auto;
			}
			@include tabletBelow {
				flex-basis: 50%;
			}
			@include aboveTablet {
				&.isOpen {
				}
			}
		}
		.up-3 & {
			flex-basis: 33.33%;
			flex-shrink: 0;
			> div { 
				max-width: 310px;
				margin:auto;
			}
			@include tabletBelow {
				flex-basis: 50%;
			}
			@include aboveTablet {
				&.isOpen {
				}
			}
		}
		.up-4 & {
			flex-basis: 25%;
			flex-shrink: 0;
			@include tabletBelow {
				flex-basis: 50%;
			}
			@include aboveTablet {
				&.isOpen {
				}
			}
		}
	}

	@include tabletBelow {
		.stop-wrapper {
			padding-left:12px;
			padding-right:12px;
		}
		&.isOpen {
			opacity: 1;
			background: rgba(0, 0, 0, 0.88);
			color: #fff;
			padding-top: 65px;
			padding-bottom: 90px;
			max-width: 100%;
			flex-basis: 100%;
			display:block;
			.up-2 &,
			.up-3 &,
			.up-4 & {
				max-width: 100%;
				flex-basis: 100%;
			}
		}
	}
}
.stop-wrapper .text-content .no-hov a:HOVER {
	color:inherit;
}
article:not(.isOpen) .text-content {
	opacity:0;
	animation: fadein 1s 0.2s forwards 1;
}
blockquote {
	margin-bottom:2em;
}
.stop-seealso {
	// color:#888;
	margin-top:1.875em;
	a {
		color:inherit;
		text-decoration:none;
		// display: inline-block;
		border-bottom:solid 1px;
		&:ACTIVE {
			opacity:0.5;
		}
	}
}
.stop-credits {
	margin-top:4.5em;
	color:#888;
}
.stop-caption {
	width:100%;
	color:#888;
	margin-top:1rem;
	p { 
		&:first-child { margin-top:0; }
		&:last-child { 
			margin-bottom:3.2em; 
			@include tabletBelow {
				margin-bottom:2em;
				font-size:13px;
			}
		}
	}
}
.balance-target {
	a {
		display:block;
		margin-left:auto;
		margin-right:auto;
	}
}
.closeX {
	position: absolute;
	top: 0;
	right: 0;
	background: none;
	border: none;
	outline: none;
	border-radius: 0;
	width: 60px;
	height: 60px;
	padding: 0;
	cursor: pointer;

	&:ACTIVE {
		opacity:0.5;
	}

	&:before,
	&:after {
		content: "";
		position: absolute;
		background: white;
		pointer-events: none;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%) rotate(45deg);
	}
	&:before {
		width: 24px;
		height: 2px;
	}
	&:after {
		width: 2px;
		height: 24px;
	}
}
.description,
.more-link,
.rest-width {
	width: 100%;
	max-width: 720px;
	margin-left: auto;
	margin-right: auto;
	p:first-child {
		margin-top: 0;
	}
	// @include tabletBelow {
	// 	padding-left: 0;
	// 	padding-right: 0;
	// }
}
.audio-player {
	margin-top: 14px;
	audio {
		width: 100%;
	}
}
.audio-wrap {
	canvas {
		display: block;
		margin: auto;
		width: 36px;
		height: 36px;
	}
}
.more-link {
	margin-top:1.75em;
	a { 
		color:white; text-decoration: none;
		&:after {
			content:"→";
			margin-left: 4px;
		}
		&:HOVER {
			color:#fff;
		}
		&:ACTIVE {
			opacity:0.5;
		}
	}
}
.classification {
	// @include minus;
	color: #777;
	.up .single-el & {
		margin-top: 1.2em;
	}
	.up & {
		margin-top: 0.5em;
	}
	.results-filtered & {
		display: none;
	}
}
.credit-captions {
	color: #666;
	padding: 3rem 0 0 25px;
	&.noURL {
		padding-top: 2rem;
	}
	// @include minus;
	.count-identify {
		float: left;
		margin-left: -25px;
	}
	&.count-1 {
		padding-left: 0;
		.count-identify {
			display: none;
		}
	}
	.credit-single {
		// @include tiny;
		p {
			margin: 0;
		}
	}
	p {
		margin-top: 0;
		margin-bottom: 0.6em;
	}
	.credit-single + .caption-single {
		margin-top: 1em;
	}
}

.isOpen {
	margin: 28px 0 0;
	&:first-child {
		margin-top:0;
	}
}

.loop-1:not(.isOpen) {
	margin-top: 40px;
	@include tabletBelow {
		margin-top: 100px;
	}
}
.loop-2:not(.isOpen) {
	margin-top: 80px;
	@include tabletBelow {
		margin-top: 0;
	}
}
.loop-3:not(.isOpen) {
	margin-top: 120px;
	@include tabletBelow {
		margin-top: 100px;
	}
}
.up-2 {
	.isOpen + .loop-1:not(.isOpen) {
		margin-left: 50%;
	}
}
.up-3 {
	.isOpen + .loop-1:not(.isOpen) {
		margin-left: 33.333%;
	}
	.isOpen + .loop-2:not(.isOpen) {
		margin-left: 66.666%;
	}
	@include tabletBelow {
		.isOpen + .loop-1:not(.isOpen) {
			margin-left:50%;
		}
		.isOpen + .loop-2:not(.isOpen) {
			margin-left:0;
		}
	}
}
.up-4 {
	.isOpen + .loop-1:not(.isOpen) {
		margin-left: 25%;
	}
	.isOpen + .loop-2:not(.isOpen) {
		margin-left: 50%;
	}
	.isOpen + .loop-3:not(.isOpen) {
		margin-left: 75%;
	}
	@include tabletBelow {
		.isOpen + .loop-1:not(.isOpen),
		.isOpen + .loop-3:not(.isOpen) {
			margin-left:50%;
		}
		.isOpen + .loop-2:not(.isOpen) {
			margin-left:0;
		}
	}
}
.moving-date-wrap {
	position: absolute;
	// top: -3px;
	// left: -24px;
	left:0;
	right:0;
	top:40px;
	height:40px;
	// width: 100%;
	// right:-9px;
	// height: 50px;
	// overflow: hidden;
	// @include tabletBelow {
	// 	right:0;
	// }
}
.moving-date {
	position: absolute;
	top: 0;
	width: 100%;
	// @include timebarstyle;
	// margin-left: -17px;
	transition-duration: 0.2s;
	transition-property: opacity;
	display: block;
	padding-left:12px;
	// &.far-left {
	// 	transform: translateX(40px) !important;
	// }
	// &.far-right {
	// 	transform: translateX(100%) !important;
	// 	margin-left:-130px;
	// }
	text-align:center;
}
.description,
.more-link {
	display: none;
	opacity: 0;
	.isOpen & {
		display: block;
		animation: fadein 0.7s forwards;
	}
}
</style>
